import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import { surtitle100, headline100 } from "css/text"

const Header = styled.header`
  color: white;
  text-align: center;
  position: absolute;
  margin-top: 15%;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(var(--grid-col-num), minmax(0, 1fr));
  grid-template-rows: [kicker subtitle] min-content [mid-line] min-content [title];
  column-gap: var(--grid-gap);
  padding: 0 var(--outer-margin);
`

const H1 = styled.h1`
  ${headline100}
  grid-column: 2 / -2;
  grid-row: mid-line / title;
`

const Kicker = styled.div`
  ${surtitle100}
  grid-column: 2 / -2;
  grid-row: kicker / mid-line;
`

const SubTitle = styled.div`
  ${surtitle100}
  grid-column: 2 / -2;
  grid-row: subtitle / mid-line;
`

export default function PageTitleBlock({ title, subtitle, kicker }) {
  const console = useConsole()

  return (
    <Header className='page-title-block'>
      {kicker && <Kicker>{kicker}</Kicker>}
      <H1>{title}</H1>
      {subtitle && <SubTitle>{subtitle}</SubTitle>}
    </Header>
  )
}
